import { useEffect, useState } from "react";
import { LogIn } from "lucide-react";
import { LOGO_PIN } from "@/content";

const links = [
  { label: "Problem", id: "problem" },
  { label: "Solution", id: "solution" },
  { label: "How It Works", id: "how" },
  { label: "Impact", id: "impact" },
  { label: "Market", id: "market" },
];

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (window.__lenis && el) window.__lenis.scrollTo(el, { offset: -90 });
  else el?.scrollIntoView({ behavior: "smooth" });
};

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "border-b border-white/10 bg-ink/70 backdrop-blur-xl" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-24 max-w-7xl items-center justify-between px-6">
        <a href="/" data-testid="nav-logo" className="flex items-center gap-3">
          <img src={LOGO_PIN} alt="GeoDyn" className="h-20 w-20 object-contain drop-shadow-[0_0_14px_rgba(0,229,255,0.55)]" />
          <span className="font-heading text-lg font-extrabold leading-none tracking-tight">
            GEODYN <span className="text-brand-green">PARKING</span>
          </span>
        </a>

        <nav className="hidden items-center gap-9 lg:flex">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollTo(l.id)}
              className="font-mono text-xs uppercase tracking-widest text-white/60 transition-colors hover:text-white"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-3 sm:gap-4">
          <button
            type="button"
            data-testid="nav-login-cta"
            aria-disabled="true"
            className="hidden items-center gap-2 rounded-full border border-white/20 px-4 py-2.5 text-sm font-semibold text-white/80 transition-colors hover:border-brand-cyan/50 hover:text-white sm:inline-flex"
          >
            <LogIn className="h-4 w-4 text-brand-cyan" />
            Login / App
          </button>
          <button
            data-testid="nav-demo-cta"
            onClick={() => scrollTo("demo")}
            className="rounded-full bg-brand-green px-5 py-2.5 text-sm font-semibold text-black transition-transform hover:-translate-y-0.5 hover:bg-[#9fd94f] hover:shadow-[0_0_24px_rgba(141,198,63,0.45)]"
          >
            Request a Demo
          </button>
        </div>
      </div>
    </header>
  );
};
